import { HttpService, type TLocalidade } from '@/infra'

export type TCredenciaisLogin = {
  usuario: string
  senha: string
}

export type TLoginErrorResponse = {
  titulo: string
  descricao: string
  codigoErro?: string
}

export const perfilDoUsuario = {
  Recepcionista: 'Recepcionista',
  Prospector: 'Prospector',
  Vendedor: 'Vendedor',
  AssessorImobiliario: 'AssessorImobiliario',
  GerenteDeVendas: 'GerenteDeVendas',
  AdministradorDaPlataforma: 'AdministradorDaPlataforma',
} as const
export type TPerfilUsuario = (typeof perfilDoUsuario)[keyof typeof perfilDoUsuario]

export type TUsuarioLogado = {
  expiracao: string
  nome: string
  grupoDeUnidadesDeNegocioId: string
  grupoDeUnidadesDeNegocioNome: string
  localidade?: TLocalidade
  usuarioLogadoId: string
  possuiDadosComissao: boolean
  usuarioTeste: boolean
  fotoDaUnidadeDeNegocio: string
  perfilDoUsuario: TPerfilUsuario
}

export class LoginService extends HttpService {
  execute = async (credenciais: TCredenciaisLogin) => {
    const response = await this.http.post<TUsuarioLogado, TCredenciaisLogin>(`/api/v2/Login`, credenciais)
    return response
  }
}
